<app-header />
<div class="container-xxl mh-500">
	<section class="text-center text-basecolor">
		<h2 class="text-uppercase text-xl">{{ "payment.esitoPayment" | translate }}</h2>
		<div>
			<p>
				<span class="richiestaMessage"> {{ messaggio }}</span>
				<br /><!-- TODO: Label -->
				<span class="richiestaMessage">La transazione ha avuto esito {{ esito }}</span>
			</p>
			<div class="col-sm-12 text-center">
				<span>
					<a
						routerLink="/private/purchase-summary"
						class="btn btn-red"
					>
						{{ "payment.purchaseSummary" | translate }}
					</a>
				</span>
			</div>
		</div>
	</section>
</div>